let preloading: Promise<unknown> | undefined;

/**
 * Fetches the experiment client chunk ahead of a CTA that navigates on click, which cannot wait for
 * useExposureEvent's dynamic import and would otherwise lose the exposure with the document.
 */
const preloadExperimentClient = () => {
  if (!preloading) {
    preloading = import('@amplitude/experiment-js-client').catch(() => undefined);
  }

  return preloading;
};

export default preloadExperimentClient;
